/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Fedorov Maxim
 * @version 1.0.1
 * @since 1.0.1
 */
import { createAction } from '../../../../../modules/app/createAction';
import {
    LOAD_LIST_INQUIRIES_FAIL,
    LOAD_LIST_INQUIRIES_REQUEST,
    LOAD_LIST_INQUIRIES_SUCCESS,
    LOAD_LIST_ORDERS_FAIL,
    LOAD_LIST_ORDERS_REQUEST,
    LOAD_LIST_ORDERS_SUCCESS,
} from './widgetOrderInquiriesConstants';
import {
    IWidgetInquiries, IWidgetOrders,
    TLoadInquiriesFailAction,
    TLoadInquiriesRequestAction,
    TLoadInquiriesSuccessAction, TLoadOrdersFailAction, TLoadOrdersRequestAction, TLoadOrdersSuccessAction,
} from './widgetOrderInquiriesTypes';

/*
* -------------------------------------------
*        LOAD INQUIRIES LIST
* -------------------------------------------
*/

export const widgetInquiriesRequest = (): TLoadInquiriesRequestAction =>
    createAction(LOAD_LIST_INQUIRIES_REQUEST);

export const widgetInquiriesSuccess = (payload: IWidgetInquiries[]): TLoadInquiriesSuccessAction =>
    createAction(LOAD_LIST_INQUIRIES_SUCCESS, payload);

export const widgetInquiriesFail = (payload: string): TLoadInquiriesFailAction =>
    createAction(LOAD_LIST_INQUIRIES_FAIL, payload);

/*
* -------------------------------------------
*        LOAD ORDERS LIST
* -------------------------------------------
*/

export const widgetOrderRequest = (): TLoadOrdersRequestAction =>
    createAction(LOAD_LIST_ORDERS_REQUEST);

export const widgetOrderSuccess = (payload: IWidgetOrders[]): TLoadOrdersSuccessAction =>
    createAction(LOAD_LIST_ORDERS_SUCCESS, payload);

export const widgetOrderFail = (payload: string): TLoadOrdersFailAction =>
    createAction(LOAD_LIST_ORDERS_FAIL, payload);
